import { createFileRoute } from "@tanstack/react-router"

import { loadIndividualInspector } from "@/admin/individuals/individual-inspector-data"
import { IndividualInspectorPage } from "@/admin/individuals/individual-inspector-page"

export const Route = createFileRoute("/_admin/admin/individuals/$individualId")(
  {
    loader: ({ params }) =>
      loadIndividualInspector({ data: { individualId: params.individualId } }),
    component: () => (
      <IndividualInspectorPage inspector={Route.useLoaderData()} />
    ),
  }
)
